<script setup>
    import LucideIcon from './LucideIcon.vue'
</script>
<template>
    <LucideIcon name="Tag"/>
</template>